/**
 * Breadcrumb Navigation Context Storage
 * Stores collection navigation context in sessionStorage for accurate breadcrumbs
 * without polluting URLs with parameters
 */

console.log('Breadcrumb Navigation JS loaded!');

(function() {
  'use strict';

  // Store navigation context when clicking product cards
  function storeNavigationContext() {
    console.log('Breadcrumb Navigation: Storing context...');
    
    // Check if we're on a collection page
    if (!window.location.pathname.includes('/collections/')) {
      console.log('Not on collection page, skipping context storage');
      return;
    }

    // Get current collection information
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
    console.log('Collection handle:', collectionHandle);
    if (!collectionHandle) return;

    // Get collection title from page elements
    let collectionTitle = '';
    
    // Try multiple selectors to find collection title
    const titleSelectors = [
      '.collection-hero__title',
      '.page-title',
      '.collection-title',
      'h1',
      '[data-collection-title]'
    ];
    
    let titleElement = null;
    for (const selector of titleSelectors) {
      titleElement = document.querySelector(selector);
      if (titleElement) {
        collectionTitle = titleElement.textContent.trim();
        break;
      }
    }
    
    // Clean up the collection title - remove "Collection:" prefix and product counts
    if (collectionTitle) {
      // Remove "Collection:" prefix if present
      collectionTitle = collectionTitle.replace(/^Collection:\s*/i, '');
      
      // Remove product counts like [607] or (607) at the end
      collectionTitle = collectionTitle.replace(/\s*[\[\(]\d+[\]\)]\s*$/, '');
      
      // Trim any extra whitespace
      collectionTitle = collectionTitle.trim();
    }
    
    // Final fallback - capitalize handle
    if (!collectionTitle) {
      collectionTitle = collectionHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }

    // Store the navigation context
    const navigationContext = {
      collectionUrl: `/collections/${collectionHandle}`,
      collectionTitle: collectionTitle,
      collectionHandle: collectionHandle,
      timestamp: Date.now()
    };

    try {
      sessionStorage.setItem('breadcrumb_navigation_context', JSON.stringify(navigationContext));
      console.log('Breadcrumb context stored:', navigationContext);
    } catch (e) {
      // Silently fail if sessionStorage is not available
      console.warn('Could not store navigation context:', e);
    }
  }

  // Get stored navigation context
  function getNavigationContext() {
    try {
      const stored = sessionStorage.getItem('breadcrumb_navigation_context');
      if (stored) {
        const context = JSON.parse(stored);
        // Check if context is not too old (1 hour)
        if (Date.now() - context.timestamp < 3600000) {
          return context;
        }
      }
    } catch (e) {
      // Silently fail if sessionStorage is not available
    }
    return null;
  }

  // Clear navigation context
  function clearNavigationContext() {
    try {
      sessionStorage.removeItem('breadcrumb_navigation_context');
    } catch (e) {
      // Silently fail
    }
  }

  // Initialize when DOM is ready
  function init() {
    console.log('Breadcrumb Navigation initialized!');
    console.log('Current page:', window.location.pathname);
    
    // Store context when clicking product cards
    document.addEventListener('click', function(e) {
      console.log('Click detected on:', e.target);
      const productLink = e.target.closest('a[href*="/products/"]');
      if (productLink) {
        console.log('Product link clicked:', productLink.href);
        storeNavigationContext();
      }
    });

    // Expose functions globally
    window.BreadcrumbNavigation = {
      getNavigationContext: getNavigationContext,
      clearNavigationContext: clearNavigationContext,
      storeNavigationContext: storeNavigationContext
    };
    
    console.log('BreadcrumbNavigation object exposed:', window.BreadcrumbNavigation);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();